<div
  class="checklist-floater-action-container modal-footter"
  [ngClass]="{
    'left-0 right-0 flex items-center bottom-0 relative': fromSideNav
  }"
>
  <div class="checklist-floater-action-container-body">
    <div class="checklist-floater-item-container">
      <div class="checklist-floater-item-container-left workspace-left">
        <h1 class="checklist-floater-item-container-left-title">{{ selectedItemsArray?.length }}</h1>
        <p class="checklist-floater-item-container-left-text text-base font-bold">
          <!-- {{ selectedItemsArray?.length > 1 ? 'Items' : 'Item' }} <br /> -->
          Selected
        </p>
      </div>

      <div class="workspace-right-wrapper">
        <!-- <div class="checklist-floater-item-container-body w-[155px]" (click)="markComplete()">
          <span class="material-icons checklist-floater-item-container-body-icon  p-1 rounded-[50%]" style="font-size: 32px !important; "
            >check</span
          >
          <p class="checklist-floater-item-container-body-text font-bold" style="
          width: 123px;height: 24px;">Mark Complete</p>
        </div> -->
        <div class="checklist-floater-item-container-right   hover:bg-[#f4f4f4]" (click)="deleteChecklist()">
          <span class="checklist-floater-item-container-right-line"></span>
          <span class="material-icons checklist-floater-item-container-right-closeicon" style="font-size: 32px !important;color: #eb5757 !important" >remove_circle_outline</span>
          <p style="width: 65px;height: 24px;font-size: 16px !important;color: #eb5757 !important"  class="checklist-floater-item-container-right-closetext font-bold">Remove</p>
        </div>
        <div class="checklist-floater-item-container-right   hover:bg-[#f4f4f4]" (click)="clearSelection()">
          <span class="checklist-floater-item-container-right-line"></span>
          <span class="material-icons checklist-floater-item-container-right-closeicon" style="font-size: 32px !important;" >clear</span>
          <p style="width: 43px;height: 24px;font-size: 16px !important;"  class="checklist-floater-item-container-right-closetext font-bold">Close</p>
        </div>
      </div>
    </div>
  </div>
</div>
